module.exports = __webpack_public_path__ + "static/media/execute_typeofQuestions.2ac31cd9.png";